import {Injectable, signal} from '@angular/core';
import {BreadcrumbData} from '../models/breadcrumb-data';
import {BehaviorSubject, Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardTitleService {
  customerFirstname!:string;
  customerLastname!:string;
  breadCrumbData=new BehaviorSubject<BreadcrumbData>(new BreadcrumbData());

  get currentCustomerFirstname(){
    return this.customerFirstname;
  }
  set currentCustomerFirstname(value:string){
    this.customerFirstname = value;
  }

  get currentCustomerLastname(){
    return this.customerFirstname;
  }
  set currentCustomerLastname(value:string){
    this.customerLastname = value;
  }

}
